export const LIB_VERSION = '16.1.5'; // autogenerated 
//# sourceMappingURL=version.js.map